<style src="../assets/style.css">
</style>
<template>
    <div class="product_list">
        <div v-if="carousel.carouselitems && carousel.carouselitems.length > 0">
            <v-carousel>
                <v-carousel-item
                    class="productListCarousel"
                    v-for="(item, index) in carousel.carouselitems"
                    :key="index"
                    :src="item.media_url"
                    reverse-transition="fade"
                    transition="fade"
                >
                <!-- <div class="carousel__content" v-html="item.content"></div> -->
                </v-carousel-item>
            </v-carousel>
        </div>
        <div class="contact">
            <div class="row">
                <div class="col-12 col-lg-6">
                    <app-call-to-action v-if="contact.call_to_action_form"></app-call-to-action>
                </div>
                <div class="col-12 col-lg-6">
                    <div class="contact__map" v-if="contact.google_map" v-html="contact.google_map">
                    </div>
                    <div class="container contact__details">
                        <div class="contact__item" v-if="contact.Address[0].address">
                            <font-awesome-icon :icon="[ 'fas', 'map-marker-alt' ]" size="lg"></font-awesome-icon>
                            <p class="contact__text"> {{ contact.Address[0].address }} </p>
                        </div>
                        <div class="contact__item" v-if="contact.Address[0].email">
                            <font-awesome-icon :icon="[ 'fas', 'envelope' ]" size="lg"></font-awesome-icon>
                            <p class="contact__text"> {{ contact.Address[0].email }} </p>
                        </div>
                        <div class="contact__item" v-if="contact.Address[0].second_email">
                            <font-awesome-icon :icon="[ 'fas', 'envelope' ]" size="lg"></font-awesome-icon>
                            <p class="contact__text"> {{ contact.Address[0].second_email }} </p>
                        </div>
                        <div class="contact__item" v-if="contact.Address[0].phone">
                            <font-awesome-icon :icon="[ 'fas', 'phone' ]" size="lg"></font-awesome-icon>
                            <p class="contact__text"> {{ contact.Address[0].phone }} </p>
                        </div>
                        <div class="contact__item" v-if="contact.Address[0].second_phone">
                            <font-awesome-icon :icon="[ 'fas', 'phone' ]" size="lg"></font-awesome-icon>
                            <p class="contact__text"> {{ contact.Address[0].second_phone }} </p>
                        </div>
                        <div class="contact__item" v-if="contact.Address[0].fax">
                            <font-awesome-icon :icon="[ 'fas', 'fax' ]" size="lg"></font-awesome-icon>
                            <p class="contact__text"> {{ contact.Address[0].fax }} </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import appCallToAction from './CallToAction'
    
    export default {
        data () {
            return {
                contact: {
                    Address: ['test'],
                    article: {
                        
                    }
                },
                carousel: {
                    carouselitems: {
                        
                    }
                }
            }
        },
        created () {
            this.getContact()
        },
        components: {
            appCallToAction
        },
        methods: {
            getContact () {
                this.$http.get(`/pages/${this.$route.path.replace('/', '')}`)
                .then(response => {
                    
                    this.contact = response.data
                    localStorage.setItem('formId', this.contact.call_to_action_form)
                })
                .then(() => {
                    if(this.contact.carousel_id) {
                        this.getCarousel(this.contact.carousel_id)
                    }
                })
                .catch(e => {
                    console.log(e)
                    this.$router.push('/404')
                })
            },
            getCarousel (id) {
                this.$http.get(`/carousel/${id}`)
                .then(response => {
                    
                    this.carousel = response.data[0]
                })
                .catch(e => {
                    console.log(e)
                })
            },
            goToArticle (slug) {
                this.$router.push({path: `/article/${slug}`})
            }
        }
    }
</script>

<style scoped>
    .giros_home_carousel_product {
        padding: 20px 0;
        margin: 30px 0;
        margin-bottom: 0;
    }
</style>

